import { html } from 'lit';
import { Route } from '../../shared/components/router/router';

export const ANY_ROUTE = '*';
export const DESCRIPTION_ROUTE = '/description';
export const COMPLETE_ROUTE = '/complete';
export const SCORM_ROUTE = '/scorm';
export const SCORM_CONTENT_ROUTE = '/scorm-content';

export const routes: Route[] = [
  {
    path: DESCRIPTION_ROUTE,
    element: async () => {
      await import('../../entry-components/course-player/course-player-description');

      return html`<lua-course-player-description></lua-course-player-description>`;
    },
  },
  {
    path: COMPLETE_ROUTE,
    element: async () => {
      await import('./course-player-completed');

      return html`<lua-course-player-complete></lua-course-player-complete>`;
    },
  },
  {
    path: SCORM_ROUTE,
    element: async () => {
      await import('../../shared/components/scorm-content/scorm-call-to-action');

      return html`<lua-scorm-call-to-action></lua-scorm-call-to-action>`;
    },
  },
  {
    path: SCORM_CONTENT_ROUTE,
    element: async () => {
      await import('../../shared/components/scorm-content/scorm-content');

      return html`<lua-scorm-content></lua-scorm-content>`;
    },
  },
  {
    path: ANY_ROUTE,
    element: async () => {
      return html`<slot></slot>`;
    },
  },
];
